export const iosStore =
    "https://apps.apple.com/us/app/live-dispatch/id1459782483";
export const playStore =
    "https://play.google.com/store/apps/details?id=com.asritsolutions.dispatch";

export const iosApp = "com.asritsolutions.dp://track?slug=";
export const playApp = "com.asritsolutions.dp://track?slug=";
